const maxSize = 31457280;
export default maxSize;
